import { render, staticRenderFns } from "./CommitteesForm.vue?vue&type=template&id=f10905c2"
import script from "./CommitteesForm.vue?vue&type=script&lang=ts"
export * from "./CommitteesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports